module.exports = __webpack_public_path__ + "static/media/roq-small.cdbc952c.png";